const { App, react2angular } = require('../../../react-dist/adminOdsComponent').reactLibrary; // eslint-disable-line
angular.module('jv.React.Admin.ODS', ['jv.Admin.ODS.controller', 'ngRoute']).component('adminOdsComponent', react2angular(App, ['translations']))
  .run([function () {
    if (!window.companyProperties.isODSFlagEnabled) {
      window.location.href = '/admin/info/accessDenied.html';
    }
  }]);// eslint-disable-line